import React, { useState } from 'react'
import { Map, Marker, Overlay } from 'pigeon-maps'
import Papa from 'papaparse';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import './mymap.css';



const SimpleMap = () => {
  // Array von Markern mit ihren Koordinaten und benannten Links
  const markers = [
    { 
      id: 1, 
      lat: 47.88, 
      lng: 13.35111111, 
      text: 'MONDSEE', 
      links: [
        { /*data: '25C', */label: 'Wetter', url: './wetter/mondsee' },
        { label: 'Bodenfeuchte', url: './bodenfeuchte/mondsee' },
        { label: 'Bodentemperatur', url: './bodentemperatur/mondsee' },
        { label: 'Baumumfang', url: './baumumfang/mondsee' },
      ]
    },
    { 
      id: 2, 
      lat: 47.4039, 
      lng: 12.5106, 
      text: 'JOCHBERG', 
      links: [
        { label: 'Wetter', url: './wetter/jochberg' },
        { label: 'Bodenfeuchte', url: './bodenfeuchte/jochberg' },
        { label: 'Bodentemperatur', url: './bodentemperatur/jochberg' },
        { label: 'Baumumfang', url: './baumumfang/jochberg' },
      ]
    },
    { 
      id: 3, 
      lat: 47.0833, 
      lng: 16.0684, 
      text: 'FÜRSTENFELD', 
      links: [
        { label: 'Wetter', url: './wetter/fuerstenfeld'},
        { label: 'Bodenfeuchte', url: './bodenfeuchte/fuerstenfeld' },
        { label: 'Bodentemperatur', url: './bodentemperatur/fuerstenfeld' },
      ]
    },
    { 
      id: 4, 
      lat: 47.1113, 
      lng: 14.4632, 
      text: 'MURAU', 
      links: [
        { label: 'Wetter', url: './wetter/murau' },
        { label: 'Bodenfeuchte', url: './bodenfeuchte/murau' },
        { label: 'Bodentemperatur', url: './bodentemperatur/murau' },
        { label: 'Baumumfang', url: './baumumfang/murau' },
      ]
    },
     { 
      id: 5, 
      lat: 48.17685, 
      lng: 16.3093, 
      text: 'WIEN SCHÖNBRUNN', 
      links: [
        { label: 'Wetter', url: './wetter/wien-schoenbrunn' },
      ]
    },
    { 
      id: 6, 
      lat: 48.10694444, 
      lng: 16.0772, 
      text: 'KLAUSEN-LEOPOLDSDORF', 
      links: [
        { label: 'Wetter', url: './wetter/klausen-leopoldsdorf' },
        { label: 'Bodenfeuchte', url: './bodenfeuchte/klausen-leopoldsdorf' },
        { label: 'Bodentemperatur', url: './bodentemperatur/klausen-leopoldsdorf' },
        { label: 'Baumumfang', url: './baumumfang/klausen-leopoldsdorf' },
      ]
    },
    { 
      id: 7, 
      lat: 48.391396, 
      lng: 16.700893, 
      text: 'MATZEN', 
      links: [
        { label: 'Wetter', url: './wetter/matzen' },
        { label: 'Bodenfeuchte', url: './bodenfeuchte/matzen' },
        { label: 'Bodentemperatur', url: './bodentemperatur/matzen' },
      ]
    },
    { 
      id: 8, 
      lat: 47.63333333, 
      lng: 15.65694444, 
      text: 'MÜRZZUSCHLAG', 
      links: [
        { label: 'Wetter', url: './wetter/muerzzuschlag' },
        { label: 'Bodenfeuchte', url: './bodenfeuchte/muerzzuschlag' },
        { label: 'Bodentemperatur', url: './bodentemperatur/muerzzuschlag' },
        { label: 'Baumumfang', url: './baumumfang/muerzzuschlag' },
      ]
    },
    { 
      id: 9, 
      lat: 48.6342, 
      lng: 15.4266, 
      text: 'NEUPÖLLA', 
      links: [
        { label: 'Wetter', url: './wetter/neupoella' },
      ]
    },
    { 
      id: 10, 
      lat: 47.48333333, 
      lng: 16.55027778, 
      text: 'UNTPULLENDORF', 
      links: [
        { label: 'Wetter', url: './wetter/unterpullendorf' },
        { label: 'Bodenfeuchte', url: './bodenfeuchte/unterpullendorf' },
        { label: 'Bodentemperatur', url: './bodentemperatur/unterpullendorf' },
        { label: 'Baumumfang', url: './baumumfang/unterpullendorf' },
      ]
    },
    { 
      id: 11, 
      lat: 48.68039, 
      lng: 14.7401, 
      text: 'WEITRA', 
      links: [
        { label: 'Bodenfeuchte', url: './bodenfeuchte/weitra' },
        { label: 'Bodentemperatur', url: './bodentemperatur/weitra' },
      ]
    },
     { 
      id: 12, 
      lat: 47.7979247, 
      lng: 15.6038552, 
      text: 'GIPPEL', 
      links: [
        { label: 'Wetter', url: './wetter/gippel' },
        { label: 'Bodenfeuchte', url: './bodenfeuchte/gippel' },
        { label: 'Bodentemperatur', url: './bodentemperatur/gippel' },
      ]
    },
     { 
      id: 13, 
      lat: 46.9557511, 
      lng: 14.321348, 
      text: 'KOLLERHUBE', 
      links: [
        { label: 'Wetter', url: './wetter/kollerhube' },
        { label: 'Bodenfeuchte', url: './bodenfeuchte/kollerhube' },
        { label: 'Bodentemperatur', url: './bodentemperatur/kollerhube' },
      ]
    }
  ]

  // State, um das Popup für den aktuellen Marker anzuzeigen
  const [activePopup, setActivePopup] = useState(null)

  // Funktion, um Popup für Marker anzuzeigen
  const handleMarkerClick = (id) => {
    if (activePopup === id) {
      setActivePopup(null)  // Schließt das Popup, wenn es bereits offen ist
    } else {
      setActivePopup(id)    // Öffnet das Popup für den gewählten Marker
    }
  }

  return (
    <Map height={490} defaultCenter={[47.5, 13.5]} defaultZoom={6.5}  minZoom={6}  
    maxZoom={18} >
      {/* Durch das Array von Markern iterieren */}
      {markers.map((marker) => (
        <Marker 
          key={marker.id}
          width={30}
          anchor={[marker.lat, marker.lng]}
          onClick={() => handleMarkerClick(marker.id)} // Klick-Handler für jedes Marker
          onMouseOver={() => handleMarkerClick(marker.id)}
          
        />
      ))}

      {/* Popup nur für den aktiven Marker anzeigen */}
      {activePopup && (
        markers.map((marker) => {
          if (marker.id === activePopup) {
            return (
              <Overlay key={marker.id} anchor={[marker.lat, marker.lng]} offset={[30, 30]}>
                <div className='mymap-popup' onMouseLeave={() => handleMarkerClick(!marker.id) } >
                  <div className='marker-header'>
                  <h3 style={{ marginBottom: '0.5rem', color: '#ffffff' }}>{marker.text}</h3>
                  </div>
                  
                  <ul>
                    {marker.links.map((link, index) => (
                      <li key={index} style={{display: 'flex', justifyContent: 'space-between', justifySelf:'center'}}>
                        <a href={link.url} rel="noopener noreferrer">{link.label}</a>
                        {/*<p style={{paddingTop:'0.3rem', marginLeft:'0.3rem'}}>{link.data}</p>*/}
                      </li>
                    ))}
                  </ul>
                </div>
              </Overlay>
            )
          }
          return null
        })
      )}
    </Map>
  )
}

function MyMap() {
  return (
    <div>
      <SimpleMap />
    </div>
  )
}

export default MyMap
